import { PencilIcon } from '@heroicons/react/outline';
import { luminance } from '../utils';
import { useTranslation } from 'react-i18next';
import { CustomEmailComponentProps } from "./EmailEditor";

function SignatureRequestEmailContant(props: CustomEmailComponentProps) {

  const { sender, disabled, value, setValue } = props;

  const { t } = useTranslation();

  return (<div className='flex flex-col bg-gray-100 h-full w-full items-center justify-center'>
    <div className='bg-white h-min flex flex-col gap-2 p-5 rounded flex-shrink-0 m-4'>
      <div className='font-gilroy text-lg font-semibold'>
        {t("Signature Request")}
      </div>
      <div className=''>
        {sender.fullName} {t("has requested you sign the following documents.")}
      </div>
      <div className="border border-dashed rounded border-gray-400 relative h-[80px] p-1">
        <textarea
          value={value}
          className='w-full h-full resize-none focus-visible:outline-none font-eina'
          name="emailContent"
          onChange={(e) => setValue(e.currentTarget.value)}
          disabled={props.disabled}
        />
        {!disabled && <PencilIcon className='w-5 h-5 absolute right-1 bottom-1 text-gray-400' />}
      </div>
      <div className='relative btn p-0 text-sm my-2 rounded blue bg-blue text-white group whitespace-nowrap cursor-help w-min' style={{ backgroundColor: sender.activeTeam?.brandingColour, color: luminance(sender.activeTeam?.brandingColour ?? "black") >= 0.5 ? "black" : "white" }}>
        <div
          className='px-[20px] py-[10px] min-w-[200px] outline-none text-center rounded'
          style={{ backgroundColor: sender.activeTeam?.brandingColour, color: luminance(sender.activeTeam?.brandingColour ?? "black") >= 0.5 ? "black" : "white" }}
        >
          {t("Review and Sign")}
        </div>
        <div className='invisible group-hover:visible absolute left-2 top-12 tooltip rounded-tl-none'>
          {t("This button will take the recipient of the email to the signable document")}
        </div>
      </div>
      <div className='h-px bg-gray-400' />
      <div className='text-gray-400 text-sm font-semibold'>
        ⚠️ {t("Warning: To prevent others from accessing your document, please do not forward this email.")}
      </div>
    </div>
  </div>)
}

export default SignatureRequestEmailContant;
